import { render, staticRenderFns } from "./IcraOdemeEmrininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=template&id=fb6bed82"
import script from "./IcraOdemeEmrininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./IcraOdemeEmrininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports